/* eslint-disable max-len */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */

import { EventTypes } from 'redux-segment';

import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';

export const GET_PRODUCTS_REQUEST = 'GET_PRODUCTS_REQUEST';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAILURE = 'GET_PRODUCTS_FAILURE';
export const ADD_PRODUCT_REQUEST = 'ADD_PRODUCT_REQUEST';
export const ADD_PRODUCT_SUCCESS = 'ADD_PRODUCT_SUCCESS';
export const ADD_PRODUCT_FAILURE = 'ADD_PRODUCT_FAILURE';
export const PRODUCT_SAVED_RESET = 'PRODUCT_SAVED_RESET';
export const EDIT_PRODUCT_REQUEST = 'EDIT_PRODUCT_REQUEST';
export const EDIT_PRODUCT_SUCCESS = 'EDIT_PRODUCT_SUCCESS';
export const EDIT_PRODUCT_FAILURE = 'EDIT_PRODUCT_FAILURE';

export function fetchProducts(salonId) {
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint: `product/quick/${salonId}/`,
      authenticated: true,
      types: [GET_PRODUCTS_REQUEST, GET_PRODUCTS_SUCCESS, GET_PRODUCTS_FAILURE],
    },
  };
}

export const addProduct = (salonId, title, brand, sub_brand, price, quantityInStock, barcode, selectedTaxes, selectedFees, isTaxExempt, taxExemptReason) => {
  const product = {
    salon_id: salonId,
    title,
    brand,
    sub_brand,
    price,
    quantity: quantityInStock,
    barcode,
    fee_ids: selectedFees,
    tax_ids: selectedTaxes,
    is_tax_exempt: isTaxExempt,
    tax_exempt_reason: taxExemptReason,
  };

  if (!barcode) {
    delete product.barcode;
  }
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(product),
  };
  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint: `product/salon/${salonId}/product/`,
      authenticated: true,
      types: [ADD_PRODUCT_REQUEST, ADD_PRODUCT_SUCCESS, ADD_PRODUCT_FAILURE],
      config,
    },
    meta: {
      analytics: {
        // eventType: EventTypes.track,
        eventPayload: {
          event: 'addProduct',
          properties: {
            title,
          },
        },
      },
    },
  };
};

export const resetSavedProperty = () => {
  return {
    type: PRODUCT_SAVED_RESET,
    meta: {
      analytics: EventTypes.track,
    },
  };
};

export const editProduct = (product, productId) => {
  const config = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(product),
  };

  return {
    [AUTH_API]: {
      api_root: CONF.stockApiRoot,
      endpoint: `product/${productId}/`,
      authenticated: true,
      types: [EDIT_PRODUCT_REQUEST, EDIT_PRODUCT_SUCCESS, EDIT_PRODUCT_FAILURE],
      config,
    },
  };
};
